/*-----------------------------------------------------------------------------/
/ Custom Theme JS — Hitpin Golf
/ All site-wide customizations live here.
/ This file survives theme updates if copied to the new theme's assets folder.
/-----------------------------------------------------------------------------*/

/* ═══════════════════════════════════════════════════════════════════════════════
   1. DYNAMIC PRICE IN ADD-TO-CART BUTTON
   Updates the button text to show total price (unit × quantity) and
   reacts to quantity changes and variant switches.
   Works with Venue V18 (Safe As Milk) — uses <staged-action-text>,
   <quantity-input>, and fetches price from Shopify Product API.
   ═══════════════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── Shopify money formatter ── */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '{{amount}} kr';

    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ' ';
      decimal = decimal || ',';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var frac = parts[1] ? decimal + parts[1] : '';
      return whole + frac;
    }

    var key = formatString.match(placeholderRegex);
    if (!key || !key[1]) return cents / 100 + ' kr';

    var value;
    switch (key[1]) {
      case 'amount':
        value = fmt(cents, 2);
        break;
      case 'amount_no_decimals':
        value = fmt(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = fmt(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = fmt(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = fmt(cents, 0, ' ', '');
        break;
      case 'amount_with_apostrophe_separator':
        value = fmt(cents, 2, "'", '.');
        break;
      default:
        value = fmt(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  /* ── Main init ── */
  function initDynamicPrice() {

    // ── 1. Find the product form ──
    var productForm = document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;

    // ── 2. Find the add-to-cart button and its text target ──
    var addBtn = productForm.querySelector('button[name="add"]');
    if (!addBtn) return;

    // Venue V18: text lives inside <staged-action-text>
    var btnTextTarget =
      addBtn.querySelector('staged-action-text') ||
      addBtn.querySelector('.staged-action__text') ||
      addBtn;

    // ── 3. Find the quantity input ──
    // In Venue V18 it sits outside <form> but is linked via form="" attribute
    var qtyInput = document.querySelector('input[name="quantity"]');
    if (!qtyInput) return;

    // ── 4. Find variant input ──
    var variantInput = productForm.querySelector('input[name="id"]');

    // ── 5. Get the product URL from <product-single> ──
    var productSingle = document.querySelector('product-single');
    var productUrl = productSingle ? productSingle.dataset.productUrl : null;

    if (!productUrl) {
      // Fallback: try to extract from canonical or URL
      var canonical = document.querySelector('link[rel="canonical"]');
      var path = canonical ? new URL(canonical.href).pathname : window.location.pathname;
      if (path.indexOf('/products/') === 0) {
        productUrl = path;
      }
    }

    if (!productUrl) {
      console.warn('[Hitpin] Could not determine product URL');
      return;
    }

    // ── 6. Money format ──
    var moneyFormat = '{{amount_no_decimals_with_space_separator}} kr';
    if (typeof theme !== 'undefined') {
      moneyFormat = theme.money_product_price_format || theme.money_format || moneyFormat;
    }

    // ── 7. Button label (respects active language) ──
    var btnLabel = '';
    if (typeof theme !== 'undefined' && typeof theme.localize === 'function') {
      btnLabel = theme.localize('ADD_TO_CART');
    }
    if (!btnLabel) {
      btnLabel = (btnTextTarget.textContent || '').trim();
    }
    if (!btnLabel) btnLabel = 'Lägg i varukorg';

    // ── 8. Fetch product data from Shopify API and wire everything up ──
    fetch(productUrl + '.js')
      .then(function (res) { return res.json(); })
      .then(function (productData) {
        if (!productData || !productData.variants) {
          console.warn('[Hitpin] No product data from API');
          return;
        }

        // Build a lookup map: variant ID → price
        var priceMap = {};
        for (var i = 0; i < productData.variants.length; i++) {
          priceMap[productData.variants[i].id] = productData.variants[i].price;
        }

        // Get current unit price
        var unitPrice = 0;
        if (variantInput) {
          unitPrice = priceMap[variantInput.value] || 0;
        }
        if (!unitPrice) {
          unitPrice = productData.variants[0].price;
        }

        // ── Update function ──
        function update() {
          // Don't override sold out / unavailable
          var currentText = (btnTextTarget.textContent || '').trim();
          if (typeof theme !== 'undefined' && typeof theme.localize === 'function') {
            var soldOut = theme.localize('SOLD_OUT');
            var unavailable = theme.localize('UNAVAILABLE');
            if (currentText === soldOut || currentText === unavailable) return;
          }
          // Don't override while "adding to cart" animation is playing
          if (addBtn.classList.contains('is-loading') || addBtn.disabled) return;

          var qty = parseInt(qtyInput.value, 10) || 1;
          var total = unitPrice * qty;
          btnTextTarget.textContent = btnLabel + ' \u2022 ' + formatMoney(total, moneyFormat);
        }

        // ── Quantity event listeners ──
        qtyInput.addEventListener('change', update);
        qtyInput.addEventListener('input', update);

        // +/- buttons in <quantity-input>
        var qtyContainer = qtyInput.closest('quantity-input') || qtyInput.parentElement;
        if (qtyContainer) {
          qtyContainer.addEventListener('click', function (e) {
            if (e.target.closest('button')) {
              setTimeout(update, 50);
              setTimeout(update, 150);
            }
          });
        }

        // MutationObserver on value attribute
        new MutationObserver(update).observe(qtyInput, {
          attributes: true,
          attributeFilter: ['value'],
        });

        // Poll for programmatic .value changes
        var lastQty = qtyInput.value;
        setInterval(function () {
          if (qtyInput.value !== lastQty) {
            lastQty = qtyInput.value;
            update();
          }
        }, 200);

        // ── Variant change listeners ──
        if (variantInput) {
          function onVariantChange() {
            var newPrice = priceMap[variantInput.value];
            if (newPrice) {
              unitPrice = newPrice;
              update();
            }
          }

          variantInput.addEventListener('change', onVariantChange);
          new MutationObserver(onVariantChange).observe(variantInput, {
            attributes: true,
            attributeFilter: ['value'],
          });
        }

        // ── Initial update ──
        update();
        console.log('[Hitpin] Dynamic price active — unit: ' + formatMoney(unitPrice, moneyFormat));
      })
      .catch(function (err) {
        console.warn('[Hitpin] Failed to fetch product data:', err);
      });
  }

  /* ── Boot ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(initDynamicPrice, 300);
    });
  } else {
    setTimeout(initDynamicPrice, 300);
  }
})();

/* ═══════════════════════════════════════════════════════════════════════════════
   2. IMAGE GRID — FIT IMAGE BLOCKS TO 3:2 RATIO
   Calculates min-height from each image block's actual width so images
   display at their natural 3:2 ratio instead of a fixed pixel height.
   Survives theme updates when custom.js is kept in assets.
   ═══════════════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  function fitImageGridBlocks() {
    var items = document.querySelectorAll('.image-grid__item--image, .image-grid__item--video');
    if (!items.length) return;

    items.forEach(function (item) {
      var img = item.querySelector('img.image-grid__bg');
      if (!img) return;

      /* Use the image's native ratio, fallback to 3:2 */
      var w = img.getAttribute('width');
      var h = img.getAttribute('height');
      var ratio = (w && h) ? (parseInt(h) / parseInt(w)) : (2 / 3);

      /* Set min-height based on the block's rendered width */
      var blockWidth = item.offsetWidth;
      item.style.minHeight = Math.round(blockWidth * ratio) + 'px';
    });
  }

  /* Run on load and resize */
  function init() {
    fitImageGridBlocks();
    window.addEventListener('resize', fitImageGridBlocks);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 300); });
  } else {
    setTimeout(init, 300);
  }
})();

/* ═══════════════════════════════════════════════════════════════════════════════
   3. KLAVIYO POPUP INTEGRATION
   Intercepts the Venue theme's built-in newsletter popup form and sends
   the email to Klaviyo's client-side subscription API instead of Shopify's
   /contact endpoint. This adds the subscriber to the Newsletter list
   (WCx2zJ) which triggers the Welcome Series Flow.

   Hides the popup for:
   - Logged-in Shopify customers (have purchased / have account)
   - Visitors already identified by Klaviyo (clicked a Klaviyo email link)
   - Visitors who previously submitted this popup (cookie + localStorage)
   - Shopify customers tagged "newsletter" (returning buyers cookied by Shopify)

   All code in custom.js — survives theme updates.
   ═══════════════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var KLAVIYO_COMPANY_ID = 'SeNscZ';
  var KLAVIYO_LIST_ID = 'WCx2zJ';
  var COOKIE_NAME = 'hitpin_klaviyo_subscribed';
  var COOKIE_DAYS = 365;
  var LS_KEY = 'hitpin_klaviyo_subscribed';

  /* ── Cookie helpers ── */
  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  /* ── Persistence: set both cookie AND localStorage for resilience ── */
  function markAsSubscribed() {
    setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
    try { localStorage.setItem(LS_KEY, '1'); } catch (e) { /* silent */ }
  }

  function wasAlreadySubscribed() {
    if (getCookie(COOKIE_NAME)) return true;
    try { if (localStorage.getItem(LS_KEY)) return true; } catch (e) { /* silent */ }
    return false;
  }

  /* ── Check if visitor is a logged-in Shopify customer ── */
  function isLoggedIn() {
    var meta = document.querySelector('meta[name="logged-in-customer-id"]');
    if (meta && meta.content && meta.content.length > 0) return true;
    if (typeof window.theme !== 'undefined' && window.theme.customer) return true;
    return false;
  }

  /* ── Check if Klaviyo already knows this visitor ──
       When a visitor clicks a link in a Klaviyo email, Klaviyo sets an
       __kla_id cookie that identifies them. If that cookie exists,
       they are a known contact — likely already subscribed or a customer. */
  function isKlaviyoIdentified() {
    return !!getCookie('__kla_id');
  }

  /* ── Check if Shopify's own tracking cookie indicates a customer ──
       Shopify sets __st_logged_in for logged-in sessions. Some themes also
       expose the customer object in a script tag. */
  function isShopifyCustomer() {
    if (getCookie('__st_logged_in')) return true;
    if (getCookie('_shopify_s') && getCookie('_shopify_y')) {
      if (getCookie('_secure_session_id')) return true;
    }
    return false;
  }

  /* ── Hide the popup element ── */
  function hidePopup() {
    var popupSection = document.querySelector('#promo-popup') ||
                       document.querySelector('popup-dialog') ||
                       document.querySelector('[data-popup]');
    if (popupSection) {
      popupSection.style.display = 'none';
      popupSection.setAttribute('aria-hidden', 'true');
    }
  }

  /* ── Main init ── */
  function initKlaviyoPopup() {

    /*
     * Layer 1: Immediate checks (no network needed)
     * - Logged-in Shopify customer
     * - Previously submitted this popup (cookie/localStorage)
     * - Shopify secure session cookie (indicates logged-in customer)
     */
    if (isLoggedIn() || wasAlreadySubscribed() || isShopifyCustomer()) {
      hidePopup();
      return;
    }

    /*
     * Layer 2: Klaviyo-identified visitor check
     * If Klaviyo has cookie'd this visitor (they clicked a Klaviyo email),
     * they're already a known contact. Hide the popup.
     */
    if (isKlaviyoIdentified()) {
      hidePopup();
      markAsSubscribed();
      return;
    }

    /* ── Find the popup newsletter form ──
         Venue V18 uses: popup-dialog#promo-popup > ... > div.promo-pop__form > form#contact_form */
    var popupForm = document.querySelector('#promo-popup form[action*="/contact"]') ||
                    document.querySelector('.promo-pop__form form') ||
                    document.querySelector('#contact_form');

    if (!popupForm) {
      console.log('[Hitpin] Popup form not found — popup may be disabled');
      return;
    }

    console.log('[Hitpin] Klaviyo popup intercept attached to:', popupForm.id || popupForm.className);

    /* ── Intercept submit ──
         Use capture phase (3rd arg = true) to fire BEFORE Venue's own handler */
    popupForm.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var emailInput = popupForm.querySelector('input[type="email"]');
      if (!emailInput) return;

      var email = emailInput.value.trim();
      if (!email || email.indexOf('@') === -1) return;

      var submitBtn = popupForm.querySelector('button[type="submit"], input[type="submit"], button:not([type])');
      if (submitBtn) submitBtn.disabled = true;

      /* ── Send to Klaviyo Client Subscription API ── */
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Hitpin Website Popup',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: {
                    'Signup Source': 'Website Popup',
                    'Signup Page': window.location.pathname
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: KLAVIYO_LIST_ID
              }
            }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify(payload)
      })
      .then(function (response) {
        if (response.ok || response.status === 202) {
          markAsSubscribed();
          showThankYou(popupForm);
        } else {
          console.warn('[Hitpin] Klaviyo subscribe failed, status:', response.status);
          popupForm.submit();
        }
      })
      .catch(function (err) {
        console.warn('[Hitpin] Klaviyo subscribe error:', err);
        popupForm.submit();
      })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
    }, true); /* capture phase — fires before Venue's own handler */
  }

  /* ── Translations — edit here to change popup thank-you copy ── */
  var TRANSLATIONS = {
    sv: {
      thankYouTitle: 'Tack för din prenumeration!',
      thankYouBody: 'Kolla din inkorg — din 10% rabattkod är på väg.'
    },
    en: {
      thankYouTitle: 'Thanks for subscribing!',
      thankYouBody: 'Check your inbox — your 10% discount code is on its way.'
    }
  };

  function getTranslations() {
    var lang = (document.documentElement.lang || 'sv').substring(0, 2).toLowerCase();
    return TRANSLATIONS[lang] || TRANSLATIONS['sv'];
  }

  /* ── Thank-you state ── */
  function showThankYou(form) {
    var t = getTranslations();
    var popupContent = document.querySelector('#promo-popup .popup_content') ||
                       document.querySelector('#promo-popup .promo-pop__wrapper') ||
                       document.querySelector('#promo-popup') ||
                       form.parentElement;

    form.style.display = 'none';

    var heading = popupContent.querySelector('#promo-popup-title, h4, h3, h2');
    var bodyText = popupContent.querySelector('.promo-pop__desc');
    var formWrap = popupContent.querySelector('.promo-pop__form');

    var thankYou = document.createElement('div');
    thankYou.className = 'hitpin-popup-thankyou';
    thankYou.innerHTML =
      '<div style="text-align:center;padding:20px 0;">' +
        '<p style="font-size:1.4em;font-weight:700;margin-bottom:12px;">' + t.thankYouTitle + '</p>' +
        '<p style="font-size:0.95em;opacity:0.8;">' + t.thankYouBody + '</p>' +
      '</div>';

    if (heading) heading.style.display = 'none';
    if (bodyText) bodyText.style.display = 'none';
    if (formWrap) formWrap.style.display = 'none';

    /* Insert thank-you after the desc or form area */
    var insertTarget = formWrap || bodyText || form.parentNode;
    insertTarget.parentNode.insertBefore(thankYou, insertTarget.nextSibling);

    setTimeout(function () {
      var closeBtn = popupContent.querySelector('.popup_close, button[aria-label="Close (esc)"], button[aria-label="Close"]');
      if (closeBtn) closeBtn.click();
    }, 4000);
  }

  /* ── Boot ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(initKlaviyoPopup, 500);
    });
  } else {
    setTimeout(initKlaviyoPopup, 500);
  }
})();